import { Pipe } from '@angular/core';
import { PipeCurrencyEuro } from './pipeEuro';

@Pipe({
    name: 'currencyEuroSinDecimales'
})
export class PipeCurrencyEuroSinDecimales extends PipeCurrencyEuro {

    override transform(value: number
    ): string | null {
        return super.transform(value, '.0-0');
    }
}